const captchaTypes: Record<string, CaptchaType> = {
  TURNSTILE: 'turnstile',
  RECAPTCHA: 'recaptcha'
};

const captchaSizes: Record<string, CaptchaSize> = {
  NORMAL: 'normal',
  COMPACT: 'compact'
};

const captchaThemes: Record<string, CaptchaTheme> = {
  LIGHT: 'light',
  DARK: 'dark'
};

type CaptchaType = 'turnstile' | 'recaptcha';

type CaptchaSize = 'normal' | 'compact';

type CaptchaTheme = 'light' | 'dark';

export {
  captchaTypes,
  captchaSizes,
  captchaThemes,
  CaptchaType,
  CaptchaSize,
  CaptchaTheme
};
